<template>
  <div class="popup">
    <div class="shadow" @click="$emit('close')"></div>
    <div class="container">
      <header>
        <h5>Informacje</h5>
        <div class="close" @click="$emit('close')">
          <i class="material-icons">close</i>
        </div>
      </header>
      <div class="wrapper">
        <p>{{ message }}</p>
        <button class="default small" @click="$emit('close')">Zamknij</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InfoPopup',
  props: [
      'message'
  ],
  data(){
    return{
        
    }
  },
}
</script>
<style scoped lang="scss">
    div.popup { display: flex; justify-content: center; align-items: center; width: 100vw; height: 100vh; position: fixed; top: 0; left: 0; z-index: 3; }
    div.popup div.shadow { width: 100vw; height: 100vh; position: absolute; top: 0; left: 0; background: rgba(0, 0, 0, 0.5); z-index: 3; }
    div.popup div.container { width: 500px; max-height: calc(100vh - 50px); background: #fff; border-radius: 3px; z-index: 4; overflow-y: auto; }
    div.popup div.container header { display: flex; }
    div.popup div.container header h5 { margin: 0 17px; padding: 0; height: 60px; line-height: 60px; font-size: 16px; font-weight: 400; color: $grayLighter; }
    div.popup div.container header div.close { display: flex; justify-content: center; align-items: center; width: 60px; height: 60px; margin-left: auto; 
    cursor: pointer; }
    div.popup div.container header div.close i.material-icons { color: $grayLighter; font-size: 26px; }
    div.popup div.container header div.close:hover i.material-icons { color: $blackLight; }
    div.popup div.wrapper { padding: 0 17px; }
    div.popup div.wrapper { display: flex; flex-direction: column; align-items: center; }
    div.popup div.wrapper p { margin: 15px 0; padding: 0; font-size: 14px; color: $grayLight; }
    div.popup div.wrapper button { margin: 15px 0 30px 0; }
</style>

